/* eslint-disable */
import React, { useEffect, useMemo, useState } from "react";
import styles from "./LeadandRegisterPipeline.module.scss";
import { PiFunnelBold } from "react-icons/pi";
import { useDispatch, useSelector } from "react-redux";
import FilterPanel from "../InterviewPipeline/InterviewCreate/FilterPanel";
import { VscChromeClose } from "react-icons/vsc";
import Loader from "../../../components/Common/Loader/Loader";

import {
  fetchPipeline,
  updateFilter,
  setPipelineType,
  clearColumnFilter,
  clearAllColumnFilters,
  resetFilter,
} from "../../../redux-store/slices/pipelineSlice";

import { getAdminIds } from "../../../services/candidateServices";
import { decryptedAdminID } from "../../../utility";
import DetailContainer from "../../../components/CandidateDetailView/DetailContainer";
import ActiveStages from "../InterviewPipeline/ActiveStages";
import ExitStages from "../InterviewPipeline/ExitStages";

const LeadandRegisterPipeline = ({ onSelectCandidate, onSelectLeadCandidate }) => {
  const dispatch = useDispatch();

  const [activeTab, setActiveTab] = useState("active");
  const [openFilter, setOpenFilter] = useState(false);
  const [adminList, setAdminList] = useState([]);
  const [onlyMe, setOnlyMe] = useState(false);
  const [initialFilters, setInitialFilters] = useState(null);
  const [resetDateFilter, setResetDateFilter] = useState(false);

  const { currentType, pipelineByType, loading } = useSelector(
    (state) => state.pipeline,
  );

  const filters = pipelineByType?.[currentType]?.filters || {};
    const adminDetails = useSelector((state) => state.adminDetails);
    const isSuperAdmin = adminDetails.roleID == 1;
    const isTeamLeader = localStorage.getItem("teamLeader") == "true";


useEffect(() => {
  const stored = JSON.parse(localStorage.getItem("AdminList") || "[]");
  setAdminList(stored);
}, []);


useEffect(() => {
  const syncAdminList = () => {
    const stored = JSON.parse(localStorage.getItem("AdminList") || "[]");
    setAdminList(stored);
  };

  window.addEventListener("storage", syncAdminList);

  return () => {
    window.removeEventListener("storage", syncAdminList);
  };
}, []);
//  const adminList = useMemo(() => { return JSON.parse(localStorage.getItem("AdminList") || "[]"); }, []);
  // console.log(adminList,"adminList from localStorage");

  const adminID = Number(decryptedAdminID());

//  console.log(adminList,"adminList from localStorage");

useEffect(() => {
  if (!adminList.length) return;

  const state = pipelineByType[currentType];

  // ✅ prevent duplicate + parallel API call
  if (state?.hasFetched || state?.loading) return;

  let defaultAdminIds = [];

  if (isSuperAdmin) {
    defaultAdminIds = adminList.map((a) => a.id);
  } else if (isTeamLeader) {
    defaultAdminIds = [adminID];
  }else {
  defaultAdminIds = [adminID]; // ✅ NORMAL USER = SELF
}

  dispatch(
    updateFilter({
      admin_ids: defaultAdminIds,
      type: currentType,
    })
  );

  dispatch(fetchPipeline({ offset: 0 }));
}, [adminList, currentType, isSuperAdmin, isTeamLeader, adminID]);

  const applyFilter = async () => {
    try {
      // ✅ CLEAN FILTER
      const cleanedFilters = Object.fromEntries(
        Object.entries({
          ...filters,
          // admin_ids: updatedAdminIds,
        }).filter(
          ([_, value]) =>
            value !== null &&
            value !== "" &&
            !(Array.isArray(value) && value.length === 0),
        ),
      );
      // console.log(cleanedFilters,"cleanedFilters");
      
      // ✅ API CALL
      dispatch(fetchPipeline({ ...cleanedFilters, offset: 0 }));

      setOpenFilter(false);
      // console.log("_________________");
      
      // console.log("Initial Filters:", initialFilters);
      // console.log("Filters:", filters);
    } catch (err) { 
      console.log("Filter Error:", err);
    }
  };


useEffect(() => {
  if (!adminList.length) return;

  let defaultAdminIds = [];

  if (isSuperAdmin) {
    defaultAdminIds = adminList.map((a) => a.id);
  } else if (isTeamLeader) {
    defaultAdminIds = [adminID];
  }else {
  defaultAdminIds = [adminID]; // ✅ NORMAL USER = SELF
}

  setInitialFilters({
    stage_id: null,
    sub_stage_id: null,
    reason_id: null,
    first_name: null,
    mobile_number: null,
    company_name: null,
    date_from: null,
    date_to: null,
    limit: 10,
    offset: 0,
    admin_ids: defaultAdminIds,
    type: currentType,
  });
}, [adminList, currentType]);

const handleTabChange = (tab) => {
  setActiveTab(tab);

  window.__INNER_TAB__ = tab;
  window.location.hash = `Interview-${tab}`;

  const type = tab === "exit" ? "EXIT" : "ACTIVE";

  dispatch(setPipelineType(type));

  const state = pipelineByType[type];

  // ✅ Call API only if NOT fetched
  if (!state.hasFetched) {
    dispatch(fetchPipeline({
      ...state.filters,
      offset: 0
    }));
  }
};
const normalize = (obj) => {
  return Object.fromEntries(
    Object.entries(obj || {}).filter(
      ([_, v]) =>
        v !== null &&
        v !== "" &&
        !(Array.isArray(v) && v.length === 0)
    )
  );
};

const isFilterChanged = () => {
  if (!initialFilters) return false;

  const cleanInitial = normalize({
    ...initialFilters,
    admin_ids: [...(initialFilters.admin_ids || [])].sort(),
  });

  const cleanCurrent = normalize({
    ...filters,
    admin_ids: [...(filters.admin_ids || [])].sort(),
  });

  return JSON.stringify(cleanInitial) !== JSON.stringify(cleanCurrent);
};


  const showRedDot = isFilterChanged();

  useEffect(() => {
    if (window.__INNER_TAB__) {
      setActiveTab(window.__INNER_TAB__); // active / exit
    }
  }, []);

  return (
    <>
      <div className={styles.pipelineContainer}>
        {loading && <Loader open={loading} fullScreen />}

        {/* HEADER */}
        <div className="d-flex justify-content-between align-items-center">
          <div className={styles.toggleTabs}>
            {/* <div
            className={`${styles.slider} ${
              activeTab === "exit" ? styles.right : ""
            }`}
          ></div> */}

            <div
              className={`${styles.slider} ${
                activeTab === "exit" ? styles.right : ""
              } ${activeTab === "exit" ? styles.exitColor : styles.activeColor}`}
            ></div>

            <button
              className={`${styles.toggleBtn} ${
                activeTab === "active" ? styles.activeText : ""
              }`}
              onClick={() => handleTabChange("active")}
            >
              Active Stages
            </button>

            <button
              className={`${styles.toggleBtn} ${
                activeTab === "exit" ? styles.activeText : ""
              }`}
              onClick={() => handleTabChange("exit")}
            >
              Exit Stages
            </button>
          </div>

          <button
            className={`${styles.filterBtn} ${
              activeTab === "exit"
                ? styles.exitfilterBtn
                : styles.activefilterBtn
            }`}
            onClick={() => setOpenFilter(true)}
          >
            <span style={{ position: "relative", display: "inline-block" }}>
              <PiFunnelBold />

              {showRedDot && (
                <span
                  style={{
                    position: "absolute",
                    top: "-2px",
                    right: "-5px",
                    width: "8px",
                    height: "8px",
                    backgroundColor: "red",
                    borderRadius: "50%",
                  }}
                />
              )}
            </span>

            <span style={{ marginLeft: "6px" }}>Filter</span>
          </button>
        </div>

        {/* CONTENT */}
        <div className={styles.content}>
          <>
            {activeTab === "active" ? (
              <ActiveStages
                tab={activeTab}
                onSelectCandidate={onSelectCandidate}
              />
            ) : (
              <ExitStages
                tab={activeTab}
                onSelectCandidate={onSelectCandidate}
              />
            )}
          </>
        </div>

        {/* FILTER PANEL */}
        <div className={`${styles.offcanvas} ${openFilter ? styles.open : ""}`}>
          <div className={styles.offcanvasHeader}>
            <h5>Pipeline Filter</h5>

            <button
              onClick={() => setOpenFilter(false)}
              className={styles.closeBtn}
            >
              <VscChromeClose />
            </button>
          </div>

          <FilterPanel
            applyFilter={applyFilter}
            adminList={adminList}
            onlyMe={onlyMe}
            setOnlyMe={setOnlyMe}
            onClose={() => setOpenFilter(false)}
            resetDateFilter={resetDateFilter}
            setResetDateFilter={setResetDateFilter}
          />
        </div>

        {/* OVERLAY */}
        {openFilter && (
          <div
            className={styles.overlay}
            onClick={() => setOpenFilter(false)}
          />
        )}
      </div>
    </>
  );
};

export default LeadandRegisterPipeline;